import { useSelector } from 'react-redux';
import { userHasPermission, MANAGE_BILLING } from 'helpers/permissions';

export default function useCurrentPermissions() {
  const currentUser = useSelector((state) => state.user);
  const canManageBilling = userHasPermission(currentUser, MANAGE_BILLING);
  return {
    canManageBilling,
  };
}
